export const SEND_TRIGGER_EMAIL_BEGIN = "SEND_TRIGGER_EMAIL_PROFILE_BEGIN";
export const SEND_TRIGGER_EMAIL_ERROR = "SEND_TRIGGER_EMAIL_PROFILE_ERROR";
export const SEND_TRIGGER_EMAIL_SUCCESS = "SEND_TRIGGER_EMAIL_PROFILE_SUCCESS";

export const POST_SEND_GRID_EMAIL_BEGIN = "POST_SEND_GRID_EMAIL_PROFILE_BEGIN";
export const POST_SEND_GRID_EMAIL_ERROR = "POST_SEND_GRID_EMAIL_PROFILE_ERROR";
export const POST_SEND_GRID_EMAIL_SUCCESS =
    "POST_SEND_GRID_EMAIL_PROFILE_SUCCESS";
